import React from "react";

const AboutUs = () => {
  return (
    <section className="min-h-screen flex items-center justify-center p-6 pt-16 bg-gray-100">
      <article className="bg-transparent shadow-lg rounded-2xl p-8 w-full max-w-3xl">
        <header className="text-center mb-6">
          <h2 className="text-3xl font-bold text-blue-600">About Us</h2>
        </header>

        <section className="mb-6">
          <p className="text-gray-700">
            <b>Talennect</b> started in the year 2022 with the blend of young,
            talented, and energetic minds with a vision to grow and achieve
            something. <b>Talennect</b> is an aspiring firm that helps its
            clients in finding the best Recruitment and IT Solutions.
          </p>
        </section>

        <section className="mb-6">
          <p className="text-gray-700">
            We have an excellent group of people who strive to deliver the Best
            out of the Best to fulfill the needs of our clients. We bring
            together creative and strategic thinking to achieve our goals by
            exploring and innovating tailor-made solutions.
          </p>
        </section>

        <section className="mb-6">
          <h3 className="text-xl font-semibold text-blue-600">Why Us?</h3>
          <p className="text-gray-700">
            We are committed to sharing our individual brilliance in one place
            with a vision to add value to our clients by delivering timely and
            efficient solutions. We believe in building strong relationships
            with our clients to foster mutual growth.
          </p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-blue-600">Vision</h3>
          <p className="text-gray-700">
            We adapt according to our client’s needs and are always up for
            challenges while continuously learning and improving our business.
            Our mission is to connect skilled professionals with clients
            effectively.
          </p>
        </section>
      </article>
    </section>
  );
};

export default AboutUs;
